import axios from "axios";
import Cookies from 'universal-cookie';
import { gopt_token, Authorization } from "../utilities/Constants";

// Initialize the universal-cookie instance
const cookies = new Cookies();

//export const appServiceName = `${process.env.REACT_APP_GOPT_PRODUCTION_URL}`;            //production 
export const appServiceName = `${process.env.REACT_APP_GOPT_STAGING_URL}`;                //staging
// export const appServiceName = `${process.env.REACT_APP_GOPT_LOCAL_URL}`;               //development http://192.168.1.5:8000
// export const appServiceName = "http://192.168.1.5:8000";

class RestfulProvider {
    constructor() {
        this.setCommonHeaders();
    }
    setCommonHeaders = () => {
        const token = cookies.get(gopt_token);

        token &&
            (axios.defaults.headers.common[Authorization] = `Bearer ${token}`);
    };

    makeCall = (url, data, axiosMethod) => {
        const header = {
            ...((url === '/api/print_invoice2' ||
                url === '/api/print-order') &&
                { responseType: 'arraybuffer' }),
            headers: {
                "Content-Type": "application/json",
            },
        };

        if (cookies.get(gopt_token)) {
            this.setCommonHeaders();
        }

        return new Promise((resolve, reject) => {
            const response = axiosMethod(`${appServiceName}${url}`, data, header);

            response
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(
                        error
                        // ||
                        // "Server is down, please check after some time !!"
                    );
                });
        });
    };

    put = (url, data) => {
        return this.makeCall(url, data, axios.put);
    };

    post = (url, data) => {
        return this.makeCall(url, data, axios.post);
    };

    get = (url) => {
        return this.makeCall(url, undefined, axios.get);
    };

    delete = (url, request) => {
        return this.makeCall(url, { data: request }, axios.delete);
    };
}

export default new RestfulProvider();